module.exports = __webpack_public_path__ + "media/assets/images/slide-right-arrow-61abc3105673cf73f8d3daa38efe8788.svg";